import { render, staticRenderFns } from "./mdBackQueryShJzHis.vue?vue&type=template&id=33cf63a9&scoped=true"
import script from "./mdBackQueryShJzHis.vue?vue&type=script&lang=js"
export * from "./mdBackQueryShJzHis.vue?vue&type=script&lang=js"
import style0 from "./mdBackQueryShJzHis.vue?vue&type=style&index=0&id=33cf63a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cf63a9",
  null
  
)

export default component.exports